// extracted by mini-css-extract-plugin
export var centerText = "_cp-8";
export var container = "_cp-0";
export var doughnutContainer = "_cp-7";
export var legend = "_cp-a";
export var legendItemColorDisplay = "_cp-b";
export var legendItemLabel = "_cp-d";
export var legendItemValue = "_cp-c";
export var lg = "_cp-5";
export var maxWidth = "_cp-9";
export var md = "_cp-4";
export var responsive = "_cp-6";
export var sm = "_cp-3";
export var xs = "_cp-2";
export var xxs = "_cp-1";